<ng-template #globalErrorMessage let-errors="errors">
  <label
    *ngIf="errors?.required"
    class="vc-inputText-label error"
    i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.ERRORS.FIELD_REQUIRED"
    >Field is required</label
  >
  <label
    *ngIf="errors?.pattern"
    class="vc-inputText-label error"
    i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.ERRORS.SPECIAL_CHAR_NOT_ALLOWED"
    >Special characters are not allowed</label
  >
  <label
    *ngIf="errors?.maxlength"
    class="vc-inputText-label error"
    i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.ERRORS.MAX_CHAR"
    >Field maximum character: {{ errors.maxlength.requiredLength }}</label
  >
  <label *ngIf="errors?.custom" class="vc-inputText-label error">{{ errors?.custom }}</label>
</ng-template>

<form *ngIf="!error; else errorMsg" [formGroup]="form" (ngSubmit)="onSubmit()" [ngClass]="{hasLoader: isLoading}">
  <div *ngIf="form.get('personalInformation')" class="formGroup" formGroupName="personalInformation">
    <div class="formTitle" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.TITLE.PERSONAL_INFORMATION">
      Personal Information
    </div>

    <div class="vc-formUnit" [ngClass]="{error: checkField('personalInformation.firstname')}">
      <input
        type="text"
        class="vc-inputText"
        name="firstname"
        value=""
        required=""
        placeholder="firstname"
        formControlName="firstname"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.FIRSTNAME"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.FIRSTNAME">first name</label>
      <ng-container
        *ngTemplateOutlet="globalErrorMessage; context: form.get('personalInformation.firstname')"
      ></ng-container>
    </div>

    <div class="vc-formUnit" [ngClass]="{error: checkField('personalInformation.lastname')}">
      <input
        type="text"
        class="vc-inputText"
        name="lastname"
        value=""
        required=""
        placeholder="lastname"
        formControlName="lastname"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.LASTNAME"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.LASTNAME">last name </label>
      <ng-container
        *ngTemplateOutlet="globalErrorMessage; context: form.get('personalInformation.lastname')"
      ></ng-container>
    </div>
    <!-- date of biirth -->
    <label
      *ngIf="!limitDateError"
      class="vc-inputText-label"
      i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.DATE_OF_BIRTH"
    >
      Date of birth
    </label>
    <div
      *ngIf="limitDateError"
      class="vc-inputText-label errorMessage"
      i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.ERRORS.MIN_AGE"
    >
      You must be above 18 years old
    </div>

    <div class="vc-formUnit dateOfBirth" formGroupName="dateOfBirth" [ngClass]="{error: limitDateError}">
      <div
        class="vc-formUnit vc-formUnit--select"
        [ngClass]="{error: checkField('personalInformation.dateOfBirth.day')}"
      >
        <select
          name="day"
          class="vc-inputText"
          formControlName="day"
          [value]="form.get('personalInformation.dateOfBirth.day').value || ''"
        >
          <option value="" disabled i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.DAY">Day</option>
          <option
            *ngFor="let item of [].constructor(31); let dayIndex = index"
            [value]="(dayIndex + 1).toString().padStart(2, '0')"
          >
            {{ dayIndex + 1 }}
          </option>
        </select>
      </div>
      <div
        class="vc-formUnit vc-formUnit--select"
        [ngClass]="{error: checkField('personalInformation.dateOfBirth.month')}"
      >
        <select
          name="month"
          class="vc-inputText"
          formControlName="month"
          [value]="form.get('personalInformation.dateOfBirth.month').value || ''"
        >
          <option value="" disabled i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.MONTH">Month</option>
          <option
            *ngFor="let item of [].constructor(12); let monthIndex = index"
            [value]="(monthIndex + 1).toString().padStart(2, '0')"
          >
            {{ monthIndex + 1 + '/13/2020' | date: 'MMMM':'':locale }}
          </option>
        </select>
      </div>
      <div
        class="vc-formUnit vc-formUnit--select"
        [ngClass]="{error: checkField('personalInformation.dateOfBirth.year')}"
      >
        <select
          name="year"
          class="vc-inputText"
          formControlName="year"
          [value]="form.get('personalInformation.dateOfBirth.year').value || ''"
        >
          <option value="" disabled i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.YEAR">Year</option>
          <option *ngFor="let item of years" [value]="item">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="form.get('contact')" class="formGroup" formGroupName="contact">
    <div class="formTitle" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.TITLE.CONTACT_INFORMATION">
      Contact Information
    </div>

    <div class="vc-formUnit" [ngClass]="{error: checkField('contact.phone')}">
      <input
        type="text"
        class="vc-inputText"
        name="phone"
        value=""
        required=""
        placeholder="phone"
        formControlName="phone"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.PHONE"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.PHONE">phone </label>
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('contact.phone')"></ng-container>
    </div>
  </div>

  <div *ngIf="form.get('business')" class="formGroup" formGroupName="business">
    <div class="formTitle" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.TITLE.BUSINESS">Business</div>

    <div class="vc-formUnit" [ngClass]="{error: checkField('business.businessName')}">
      <input
        type="text"
        class="vc-inputText"
        name="phone"
        value=""
        required=""
        placeholder="Business name"
        formControlName="businessName"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.BUSINESS_NAME"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.BUSINESS_NAME"
        >Business name</label
      >
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('business.businessName')"></ng-container>
    </div>
  </div>

  <div class="formGroup" formGroupName="address">
    <div class="formTitle" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.TITLE.BILLING_ADDRESS">Billing Address</div>

    <div class="vc-formUnit" [ngClass]="{error: checkField('address.street')}">
      <input
        type="text"
        class="vc-inputText"
        name="street"
        value=""
        required=""
        placeholder="street"
        formControlName="street"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.STREET"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.STREET">street</label>
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.street')"></ng-container>
    </div>
    <div class="vc-formUnit" [ngClass]="{error: checkField('address.city')}">
      <input
        type="text"
        class="vc-inputText"
        name="city"
        value=""
        required=""
        placeholder="city"
        formControlName="city"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.CITY"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.CITY">city </label>
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.city')"></ng-container>
    </div>
    <div class="vc-formUnit" [ngClass]="{error: checkField('address.zip')}">
      <input
        type="text"
        class="vc-inputText"
        name="zip"
        value=""
        required=""
        placeholder="zip"
        formControlName="zip"
        i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.ZIPCODE"
      />
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.ZIPCODE">zip </label>
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.zip')"></ng-container>
    </div>
    <div class="vc-formUnit vc-formUnit--select" [ngClass]="{error: checkField('address.country')}">
      <select name="country" class="vc-inputText" formControlName="country" [value]="form.get('address.country').value">
        <option value="" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.COUNTRY">Select a country</option>
        <option *ngFor="let c of countryList" [value]="c.isoCode">
          {{ c.name }}
        </option>
      </select>
      <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.COUNTRY">country </label>
      <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.country')"></ng-container>
    </div>
    <ng-container *ngIf="addressForm.get('state')">
      <div
        *ngIf="!currentStates.length"
        class="vc-formUnit vc-formUnit"
        [ngClass]="{error: checkField('address.state')}"
      >
        <input
          type="text"
          class="vc-inputText"
          name="state"
          value=""
          required=""
          placeholder="State"
          formControlName="state"
          i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.STATE"
        />
        <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.STATE">state</label>
        <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.state')"></ng-container>
      </div>
      <div
        *ngIf="currentStates.length"
        class="vc-formUnit vc-formUnit--select"
        [ngClass]="{error: checkField('address.state')}"
      >
        <select name="state" class="vc-inputText" formControlName="state" [value]="form.get('address.state').value">
          <option value="" i18n-placeholder="@@GET_PAID.PERSONAL_INFORMATION_FORM.PLACEHOLDER.STATE">State</option>
          <option *ngFor="let s of currentStates" [value]="s.iso">
            {{ s.name }}
          </option>
        </select>
        <label class="vc-inputText-label" i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.LABEL.STATE">state </label>
        <ng-container *ngTemplateOutlet="globalErrorMessage; context: form.get('address.state')"></ng-container>
      </div>
    </ng-container>
  </div>
  <div *ngIf="error" class="errorMessage">
    <ng-container *ngIf="errorType === 'string'; else defaultError">
      {{ error }}
    </ng-container>
    <ng-template #defaultError i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.ERRORS.GLOBAL_ERROR">
      Oups ! an error occured
    </ng-template>
  </div>
  <div class="submitBtn" [ngClass]="{withoutBottomNav: isWebView}">
    <button
      [ngClass]="{disabled: form.invalid || limitDateError}"
      class="vc-btn vc-btn--primary vc-btn--large vc-btn--full vc-btn--notfull--md-up"
      type="submit"
      i18n="@@GET_PAID.PERSONAL_INFORMATION_FORM.SUBMIT_BUTTON"
    >
      Next
    </button>
  </div>
</form>

<ng-template #errorMsg>
  <vc-get-paid-error></vc-get-paid-error>
</ng-template>
